import type { CSSProperties } from 'react';

/**
 * Multi-layer background for the Shipping tab's card preview. Layer 1 is an
 * optional image (covers + centred, falls through to `none` when no URL is
 * set); Layer 2 is the gradient (top → bottom). Sleek's cards are flat
 * (partner Figma 2026-10-06), so both stops default to transparent.
 *
 * Each constant is a STATIC literal (no template assembly) so the
 * theme-constructor's schema-invariant regex scanner can prove each
 * registry knob is actually consumed in code.
 */
export const PHOTO_BG_STYLE_DELIVERY: CSSProperties = {
  backgroundImage:
    'var(--co-MyPacksDeliveryCard-photoBgImage, none), ' +
    'linear-gradient(to bottom, ' +
    'var(--co-MyPacksDeliveryCard-photoBgFrom, transparent) 0%, ' +
    'var(--co-MyPacksDeliveryCard-photoBgTo, transparent) 100%)',
  backgroundSize: 'cover, auto',
  backgroundPosition: 'center, top',
  backgroundRepeat: 'no-repeat, no-repeat',
};
